import React, {useState, useEffect} from "react";
import {connect} from "react-redux";
import axios from "axios";
import {
    useParams,
    Link
} from "react-router-dom";
import {ToastBottomEnd} from "./Toast";
import {
    toastAddErrorMessageConfig,
    toastAddSuccessMessageConfig,
    toastEditErrorMessageConfig,
    toastEditSuccessMessageConfig
} from "../../config/toastConfig";
import appConfig from "../../config/appConfig";
import {ERROR_401} from "../../config/errorPage";
import {verifyPermission} from "../../helpers/permission";
import InputRequire from "./InputRequire";
import {verifyTokenExpire} from "../../middleware/verifyToken";
import {useTranslation} from "react-i18next";
import { claimCategorySchema } from "../../validations/forms-schema";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

const ClaimCategoryForm = (props) => {

    //usage of useTranslation i18n
    const {t, ready} = useTranslation()

    const {id} = useParams();
    if (id) {
        if (!verifyPermission(props.userPermissions, 'update-claim-category'))
            window.location.href = ERROR_401;
    } else {
        if (!verifyPermission(props.userPermissions, 'store-claim-category'))
            window.location.href = ERROR_401;
    }

    const defaultData = {
        name: "",
    };
    const defaultError = {
        name: [],
    };
    const [data, setData] = useState(defaultData);
    const [error, setError] = useState(defaultError);
    const [startRequest, setStartRequest] = useState(false);

    useEffect(() => {
        async function fetchData () {
            if (id) {
                await axios.get(`${appConfig.apiDomaine}/claim-categories/${id}`)
                    .then(response => {
                        const newData = {
                            name: response.data.name.fr,
                        };
                        setData(newData);
                        setValue("name", response.data.name.fr);
                        trigger();
                    })
                    .catch(error => {
                        
                    })
                ;
            }
        }
        if (verifyTokenExpire())
            fetchData();
    }, [id, appConfig.apiDomaine]);

    const onChangeName = (e) => {
        const newData = {...data};
        newData.name = e.target.value;
        setValue("name", e.target.value);
        trigger("name");
        setData(newData);
    };

    const {
        handleSubmit,
        setValue,
        trigger,
        watch,
        register,
        reset,
        formState: { errors: clientErrors, isValid }
    } = useForm({
        resolver: yupResolver(claimCategorySchema)
    });

    const isValidData = isValid && watch("name") !== data.name;

    const getFieldError = (fieldName) => {
        const clientError = clientErrors[fieldName];
        const serverError = error[fieldName];
        
        if (serverError && serverError.length > 0) {
            return serverError;
        }
        
        if (clientError) {
          if (Array.isArray(clientError)) {
            const firstItem = clientError[0];
            if (typeof firstItem !== "string") {
              return clientError.map(item => item?.message);
            }
            return clientError;
          } else {
            return [clientError.message];
          }
        }
        
        return [];
    };

    const onSubmit = (formData) => {
        setStartRequest(true);
        if (verifyTokenExpire()) {
            if (id) {
                axios.put(`${appConfig.apiDomaine}/claim-categories/${id}`, formData)
                    .then(response => {
                        setStartRequest(false);
                        setError(defaultError);
                        ToastBottomEnd.fire(toastEditSuccessMessageConfig());
                        window.location.href = "/settings/claim_categories";
                    })
                    .catch(errorRequest => {
                        setStartRequest(false);
                        setError({...defaultError, ...errorRequest.response.data.error});
                        ToastBottomEnd.fire(toastEditErrorMessageConfig());
                    })
                ;
            } else {
                axios.post(`${appConfig.apiDomaine}/claim-categories`, formData)
                    .then(response => {
                        setStartRequest(false);
                        setError(defaultError);
                        setData(defaultData);
                        ToastBottomEnd.fire(toastAddSuccessMessageConfig());
                        reset();
                    })
                    .catch(errorRequest => {
                        setStartRequest(false);
                        setError({...defaultError, ...errorRequest.response.data.error});
                        ToastBottomEnd.fire(toastAddErrorMessageConfig());
                    })
                ;
            }
        }
    };

    const printJsx = () => {
        return (
            <div className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor" id="kt_content">
                <div className="kt-subheader   kt-grid__item" id="kt_subheader">
                    <div className="kt-container  kt-container--fluid ">
                        <div className="kt-subheader__main">
                            <h3 className="kt-subheader__title">
                                {t("Paramètres")}
                            </h3>
                            <span className="kt-subheader__separator kt-hidden"/>
                            <div className="kt-subheader__breadcrumbs">
                                <a href="#icone" className="kt-subheader__breadcrumbs-home"><i className="flaticon2-shelter"/></a>
                                <span className="kt-subheader__breadcrumbs-separator"/>
                                <Link to="/settings/claim_categories" className="kt-subheader__breadcrumbs-link">
                                    {t("Catégorie de réclamation")}
                                </Link>
                                <span className="kt-subheader__breadcrumbs-separator"/>
                                <a href="#button" onClick={e => e.preventDefault()} className="kt-subheader__breadcrumbs-link" style={{cursor: "text"}}>
                                    {
                                        id ? t("Modification") : t("Ajout")
                                    }
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                    <div className="row">
                        <div className="col">
                            <div className="kt-portlet">
                                <div className="kt-portlet__head">
                                    <div className="kt-portlet__head-label">
                                        <h3 className="kt-portlet__head-title">
                                            {
                                                id ? t("Modification de catégorie de réclamation") : t("Ajout de catégorie de réclamation")
                                            }
                                        </h3>
                                    </div>
                                </div>

                                <form method="POST" className="kt-form">
                                    <div className="kt-form kt-form--label-right">
                                        <div className="kt-portlet__body">
                                            <div className={getFieldError("name").length ? "form-group row validated" : "form-group row"}>
                                                <label className="col-xl-3 col-lg-3 col-form-label" htmlFor="name">{t("Catégorie")} <InputRequire/></label>
                                                <div className="col-lg-9 col-xl-6">
                                                    <input
                                                        id="name"
                                                        type="text"
                                                        className={getFieldError("name").length ? "form-control is-invalid" : "form-control"}
                                                        placeholder={t("Nom de la catégorie")}
                                                        {...register("name")}
                                                    />
                                                    {
                                                        getFieldError("name").length ? (
                                                            getFieldError("name").map((error, index) => (
                                                                <div key={index} className="invalid-feedback">
                                                                    {error}
                                                                </div>
                                                            ))
                                                        ) : null
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="kt-portlet__foot">
                                            <div className="kt-form__actions text-right">
                                                {
                                                    !startRequest ? (
                                                        <button type="submit" onClick={handleSubmit(onSubmit)} className="btn btn-primary" disabled={!isValidData}>{id ? t("Modifier") : t("Enregistrer")}</button>
                                                    ) : (
                                                        <button className="btn btn-primary kt-spinner kt-spinner--left kt-spinner--md kt-spinner--light" type="button" disabled>
                                                            {t("Chargement")}...
                                                        </button>
                                                    )
                                                }
                                                {
                                                    !startRequest ? (
                                                        <Link to="/settings/claim_categories" className="btn btn-secondary mx-2">
                                                            {t("Quitter")}
                                                        </Link>
                                                    ) : (
                                                        <Link to="/settings/claim_categories" className="btn btn-secondary mx-2" disabled>
                                                            {t("Quitter")}
                                                        </Link>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        ready ? (
            id ? (
                verifyPermission(props.userPermissions, 'update-claim-category') ? (
                    printJsx()
                ) : null
            ) : (
                verifyPermission(props.userPermissions, 'store-claim-category') ? (
                    printJsx()
                ) : null
            )
        ) : null
    );
};

const mapDispatchToProps = (state) => {
    return {
        userPermissions: state.user.user.permissions,
        language: state.language
    }
};

export default connect(mapDispatchToProps)(ClaimCategoryForm);
